import { render, staticRenderFns } from "./GeneralInventoryMobile.vue?vue&type=template&id=62878fed&scoped=true"
import script from "./GeneralInventoryMobile.vue?vue&type=script&lang=js"
export * from "./GeneralInventoryMobile.vue?vue&type=script&lang=js"
import style0 from "./GeneralInventoryMobile.vue?vue&type=style&index=0&id=62878fed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62878fed",
  null
  
)

export default component.exports